import { translations } from 'locales/i18n';
import * as yup from 'yup';

export const ioSettingsValidationSchema = t =>
  yup.object().shape({
    year: yup.number().required(t(translations.validation.required())),
    semesterType: yup.string().required(t(translations.validation.required())),
    examRegistration: yup.date().required(t(translations.validation.required()))
  });
